<div class="status-indicator status-indicator--{{ status() }}">
  @if (icon(); as _icon) {
    <evc-icon
      size="md"
      [icon]="_icon"></evc-icon>
  }

  <span class="status-indicator__text">
    {{ upperCase() ? text().toUpperCase() : text() }}
  </span>
</div>
